import { ResponseError, ResponseResultType } from '../../../config/api';
import { useSWR, responseInterface } from '../../../config/overrides/swr';
import API, { PROTECTED, EVENT, MEETING, PrivateMeetingDetailsResponseType } from '../../../lib/api';
import { IAuthContext, useAuth } from '../../../lib/context-providers/auth-context';
import { composeUrl } from '../../../lib/api/utils';
import { useRef } from 'react';

const { fetchMeetingPrivateDetails } = API[PROTECTED];

const fetchMeetingPrivateDetailsWrapper = async (url: string): Promise<ResponseResultType<PrivateMeetingDetailsResponseType>> => {
  const startParamsIndex = url.indexOf('?');
  const finalUrl = url.slice(0, startParamsIndex === -1 ? url.length : startParamsIndex);
  return fetchMeetingPrivateDetails(finalUrl);
};

export function useMeetingPrivateDetails(eventId: string, meetingId: string): responseInterface<PrivateMeetingDetailsResponseType, ResponseError> {
  const auth = useAuth() as IAuthContext;
  const timestamp = useRef(`ts=${Date.now()}`);

  const shouldSendRequest = [auth.isAuthenticated, eventId, meetingId].every(Boolean);
  // Add timestamp to prevent caching data
  const key = shouldSendRequest ? `${composeUrl(...[ EVENT, eventId, MEETING, meetingId ])}?${timestamp.current}` : null;

  return useSWR(key, fetchMeetingPrivateDetailsWrapper);
}
